export default "__VITE_ASSET__BZ4cO72O__"